import * as Yup from 'yup'

export const adminUpdateKYCDetailsValidationSchema = Yup.object({
  account_kyc_name: Yup.string()
    .required('KYC Account Name is required')
    .matches(/^[a-zA-Z0-9_-]+$/, 'Only alphanumeric characters, _ and - are allowed')
    .min(3, 'Minimum 3 characters required')
    .max(50, 'Maximum 50 characters are allowed'),
  business_registartion_type_uuid: Yup.string().required('Business Type is required'),
  business_name: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(350, 'Maximum 350 characters are allowed')
    .optional(),
  account_holder_name: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(300, 'Maximum 300 characters are allowed')
    .optional(),
  account_no: Yup.number()
    .typeError('Account number must be a number')
    .positive('Account number must be a positive number')
    .integer('Account number must be an integer')
    .max(999999999999999999999999999999, 'Account number cannot be more than 30 digits')
    .optional(),
  confirm_account_no: Yup.number()
    .oneOf([Yup.ref('account_no'), null], 'Account number must match')
    .typeError('Account number must be a number')
    .positive('Account number must be a positive number')
    .integer('Account number must be an integer')
    .max(999999999999999999999999999999, 'Account number cannot be more than 30 digits'),
  ifsc_swift_code: Yup.string()
    .matches(/^[a-zA-Z0-9]*$/, 'Only alphanumeric characters')
    .max(30, 'Maximum 30 characters are allowed')
    .optional(),
  account_email_id: Yup.string()
    .email('Wrong email format')
    .min(3, 'Minimum 3 characters required')
    .max(350, 'Maximum 350 characters are allowed')
    .optional(),
  account_phone_number: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(20, 'Maximum 20 characters are allowed')
    .optional(),
  address_1: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(600, 'Maximum 600 characters are allowed')
    .optional(),
  address_2: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(600, 'Maximum 600 characters are allowed')
    .optional(),
  country_id: Yup.number().optional(),
  province_id: Yup.number().optional(),
  city: Yup.string()
    .min(3, 'Minimum 3 characters required')
    .max(100, 'Maximum 100 characters are allowed')
    .optional(),
  pin_zip: Yup.number()
    .typeError('Pincode must be a number')
    .positive('Pincode must be a positive number')
    .integer('Pincode must be an integer')
    .min(100000, 'Pincode must be at least 6 digits')
    .max(999999, 'Pincode cannot be more than 6 digits')
    .optional(),
  account_kyc_document_type_uuid: Yup.string(),
  account_kyc_status: Yup.string().required('Account KYC Status is Required'),
})
